<script lang="ts">
import Navigation from "@/Components/Generics/Navigation.vue";
import NavigationLink from "@/Components/NavigationLink.vue";
import { NavigationLinkType } from "@/Types/navigation";
import { defineComponent } from "vue";

export default defineComponent({
    name: "AcpNavigation",
    components: { Navigation, NavigationLink },
    computed: {
        routes(): Array<NavigationLinkType> {
            return [
                {
                    hrefRoute: "main",
                    pageRoute: "/",
                    title: this.$trans("navigation.nav_acp_home"),
                },
                {
                    hrefRoute: "acp.companies",
                    pageRoute: "/acp/companies",
                    title: this.$trans("navigation.nav_acp_companies"),
                },
                {
                    hrefRoute: "acp.events",
                    pageRoute: "/acp/events",
                    title: this.$trans("navigation.nav_acp_events"),
                },
                {
                    title: this.$trans("navigation.nav_acp_logout"),
                    hrefRoute: "logout",
                    inertiaLinkObj: {
                        inertiaAs: "button",
                        inertiaMethod: "post",
                        inertiaPowerOff: true,
                    },
                },
            ];
        },
    },
});
</script>
<template>
    <Navigation>
        <template v-if="$page.props.auth.user">
            <NavigationLink
                v-for="route in routes"
                :key="route.title"
                :href-route="route.hrefRoute"
                :href="route.href"
                :page-route="route.pageRoute"
                :title="route.title"
                :not-a-link="route.notALink"
                :inertia-link-obj="route.inertiaLinkObj" />
        </template>

        <!-- <ul v-if="$page.props.auth.user" class="navbar-nav">
            <li class="nav-item">
                <Link :href="route('main')" class="nav-link" :class="{ active: $page.url === '/' }" aria-current="page">{{ $trans("navigation.nav_acp_home").toUpperCase() }}</Link>
            </li>
            <li class="nav-item">
                <Link class="nav-link" :class="{ active: $page.url === '/acp/companies' }" :href="route('acp.companies')">{{ $trans("navigation.nav_acp_companies").toUpperCase() }}</Link>
            </li>
            <li class="nav-item">
                <Link class="nav-link" :class="{ active: $page.url === '/acp/events' }" :href="route('acp.events')">{{ $trans("navigation.nav_acp_events").toUpperCase() }}</Link>
            </li>
            <li class="nav-item">
                <inertia-link class="nav-link" as="button" method="post" :href="route('logout')">
                    {{ $trans("navigation.nav_acp_logout").toUpperCase() }}
                    <i class="fas fa-power-off"></i>
                </inertia-link>
            </li>
        </ul> -->
    </Navigation>
</template>
